import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaDiscord, FaYoutube, FaTwitter, FaReddit } from 'react-icons/fa';
import logo from '../images/logo.png';
import '../css/footer.css';

const Footer = () => {
    const { t } = useTranslation();
    const year = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-brand">
                    <img src={logo} alt="Super People" className="footer-logo" />
                    <p className="footer-tagline">{t('footer.tagline')}</p>
                </div>

                <nav className="footer-col" aria-label={t('footer.explore')}>
                    <h4 className="footer-heading">{t('footer.explore')}</h4>
                    <Link to="/">{t('header.home')}</Link>
                    <Link to="/characters">{t('header.characters')}</Link>
                    <Link to="/map">{t('header.map')}</Link>
                    <Link to="/posts">{t('header.posts')}</Link>
                    <Link to="/survey">{t('header.survey')}</Link>
                </nav>

                <div className="footer-col">
                    <h4 className="footer-heading">{t('footer.community')}</h4>
                    <a href="https://discord.gg/superpeopleofficial" target="_blank" rel="noopener noreferrer">
                        <FaDiscord /> Discord
                    </a>
                    <a href="https://www.youtube.com/@SuperPeopleOfficialEN/" target="_blank" rel="noopener noreferrer">
                        <FaYoutube /> YouTube
                    </a>
                    <a href="https://twitter.com/playsuperpeople" target="_blank" rel="noopener noreferrer">
                        <FaTwitter /> Twitter
                    </a>
                    <a href="https://www.reddit.com/r/SuperPeople/" target="_blank" rel="noopener noreferrer">
                        <FaReddit /> Reddit
                    </a>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© {year} Super People {t('hero.eyebrow')}</p>
            </div>
        </footer>
    );
};

export default Footer;
